<template>
  <Select
    v-model="selectedLanguage"
    :options="routes"
    :optionLabel="(o: TranslatedRoute) => o.locale.toUpperCase()"
    :aria-label="$t('dbc-text-choose-language')"
    @change="onChangeLanguageOption"
    appendTo="self"
    pt:root:class="relative w-full inline-flex px-2xs gap-1 items-center hover:bg-gray cursor-pointer"
    pt:label:class="peer/label"
    pt:dropdown:class="peer-aria-expanded/label:rotate-180 duration-200"
    pt:overlay:class="flex flex-col shadow-lg bg-white rounded-b overflow-hidden w-max"
    pt:list:class="list-none my-0 pl-0"
    pt:option:class="px-xs py-2xs hover:bg-gray cursor-pointer data-[p-focused='true']/option:bg-gray data-[p-selected='true']:text-primary"
  >
    <template #dropdownicon>
      <DbcSvg name="dbc-icon-chevron-down" class="h-fit block" />
    </template>
    <template #value="slotProps">
      <span aria-hidden="true">
        {{ slotProps.value.locale.toUpperCase() }}
      </span>
      <span class="sr-only">
        {{ $t(slotProps.value.locale) }}
      </span>
    </template>
    <template #header>
      <span class="text-xs px-xs py-2xs">
        {{ $t('dbc-text-choose-language') }}
      </span>
    </template>
    <template #option="slotProps">
      <span :aria-label="$t(slotProps.option.locale)">
        <span aria-hidden="true"
          >{{ slotProps.option.locale.toUpperCase() }} |</span
        >
        {{ $t(slotProps.option.locale) }}
        <DbcSvg v-if="slotProps.option.locale === locale" name="dbc-tick" />
      </span>
    </template>
  </Select>
</template>

<script setup lang="ts">
import { changeLocale as formkitChangeLocale } from '@formkit/vue'
import type { SelectChangeEvent } from 'primevue/select'

const props = defineProps<{
  routes: TranslatedRoute[]
}>()

const { locale, setLocale } = useI18n()
const route = useRoute()
const subRoute = ref('')
const selectedLanguage = ref(
  props.routes.find((r) => r.locale === locale.value)
)

watch(
  () => route.path,
  () => {
    subRoute.value = getNestedRoutes(route)
  },
  { immediate: true }
)

function onChangeLanguageOption(e: SelectChangeEvent) {
  if (e.value.locale === locale.value) return

  setLocale(e.value.locale)

  navigateTo({
    path: `/${e.value.locale}/${e.value.path}${subRoute.value}`,
  })
}

formkitChangeLocale(locale.value)
</script>
